// Components==============
import AddActivityModal from 'components/UI/AddActivityModal/AddActivityModal';
import Input from 'components/UI/Form/Input';
import Textarea from 'components/UI/Form/Textarea';
import SkillGetter from 'components/UI/SkillGetter/SkillGetter';
import SkillModal from 'components/UI/SkillModal/SkillModal';
import TokenGetter from 'components/UI/TokenGetter/TokenGetter';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext } from 'react';
import { DreamModalContext } from '../DreamModal';
import DreamModalItem from '../DreamModalItem';
import DreamModalItems from '../DreamModalItems/DreamModalItems';
import './Edit.module.scss';
// =========================

export default function Edit() {
  const translate = useTranslate();
  const { editState, setEditState } = useContext(DreamModalContext);

  function handleSelectSkill(id: number) {
    setEditState((prev) => ({
      ...prev,
      skills: [...prev.skills, { id, amount: 1 }],
    }));
  }

  function handleDeleteSkill(id: number) {
    setEditState((prev) => ({
      ...prev,
      skills: prev.skills.filter((a) => a.id !== id),
    }));
  }

  function handleAddActivity(id: number, type: ProcessType) {
    setEditState((prev) => ({
      ...prev,
      activities: [...prev.activities, { id, type, amount: 1 }],
    }));
  }

  function handleDeleteActivity(id: number, type: ProcessType) {
    setEditState((prev) => ({
      ...prev,
      activities: prev.activities.filter((a) =>
        a.type === type ? a.id !== id : true
      ),
    }));
  }

  return (
    <div styleName="wrapper">
      <Input
        ext_formValue={editState?.name}
        ext_onChange={(e) => {
          if (e.target.value.length > 50) return;
          setEditState((prev) => ({ ...prev, name: e.target.value }));
        }}
        name="name"
        placeholder={translate('general.terms.name')}
      />
      <Textarea
        ext_formValue={editState?.description}
        ext_onChange={(e) =>
          setEditState((prev) => ({ ...prev, description: e.target.value }))
        }
        name="description"
        placeholder={translate('general.terms.description')}
      />
      <div>
        <h2>{translate('dream.dream-come-true')}</h2>
        <div styleName="grid">
          <DreamModalItems
            title="project.terms.activities"
            itemLength={editState.activities.length}
            items={
              <>
                {editState.activities?.map((activity) => (
                  <DreamModalItem
                    key={activity.id}
                    amount={activity.amount}
                    id={activity.id}
                    type={activity.type}
                  >
                    <TokenGetter
                      activity={{
                        process_type: activity.type,
                        process_id: activity.id,
                      }}
                      handleDelete={() =>
                        handleDeleteActivity(activity.id, activity.type)
                      }
                    />
                  </DreamModalItem>
                ))}
              </>
            }
            addModal={
              <AddActivityModal
                fn="add"
                origin="growth"
                handleAddToDream={handleAddActivity}
                usedForDream={editState.activities}
              />
            }
          />
          <DreamModalItems
            title="general.terms.skills"
            itemLength={editState.skills.length}
            items={
              <>
                {editState.skills?.map(
                  (skill) =>
                    skill && (
                      <DreamModalItem
                        key={skill.id}
                        amount={skill.amount}
                        id={skill.id}
                        type={'App\\Skill'}
                      >
                        <SkillGetter
                          id={skill.id}
                          handleDelete={() => handleDeleteSkill(skill.id)}
                        />
                      </DreamModalItem>
                    )
                )}
              </>
            }
            addModal={
              <SkillModal
                handleSelectSkill={handleSelectSkill}
                usedSkills={editState.skills.map((s) => s.id)}
              />
            }
          />
        </div>
      </div>
    </div>
  );
}
